"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReportTemplate = void 0;
const fp = require("fp-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const redux_observable_1 = require("redux-observable");
const Actions = require("../../actions/reports");
const ActionTypes = require("../../actionTypes/reports/update");
const ErrorHandling = require("../../utils/errorHandling");
const Types = require("../../types");
const ValidationUtils = require("../../utils/validation");
const validation_1 = require("./utils/validation");
const validate = (payload) => {
    const validation = ValidationUtils.successValidation;
    return fp.function.flow((0, validation_1.validateNameNotEmpty)(payload), (0, validation_1.validateNameLength)(payload), (0, validation_1.validateDescriptionLength)(payload), (0, validation_1.validateFieldsNotEmpty)(payload))(validation);
};
const updateReportTemplate = (action$, _store, { ajax, getToken, baseUrl }) => {
    const ajaxOptions = ({ templateUuid, payload }) => ({
        method: 'PATCH',
        url: `${baseUrl}api/reports/templates/${templateUuid}`,
        body: payload,
        headers: {
            Authorization: getToken(),
            'Content-Type': 'application/json'
        }
    });
    const ajaxCall = (action) => ajax(ajaxOptions(action)).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.updateReportTemplateSuccess(), Actions.fetchReportListRequest(action.customerId, Types.TEMPLATE))), (0, operators_1.catchError)((error) => {
        const responseError = ErrorHandling.parseAjaxErrorResponse(error);
        return (0, rxjs_1.of)(Actions.updateReportTemplateFailure(responseError));
    }));
    const mapValidationErrors = (errors) => (0, rxjs_1.of)(Actions.updateReportTemplateValidation(ValidationUtils.mapValidationErrors(errors)));
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.UPDATE_REPORT_TEMPLATE_REQUEST), (0, operators_1.map)((action) => action), (0, operators_1.mergeMap)((action) => validate(action.payload).fold(mapValidationErrors, () => ajaxCall(action))));
};
exports.updateReportTemplate = updateReportTemplate;
//# sourceMappingURL=update.js.map